export default {
  name: 'AppFooter'
};